import { metadata } from './metadata'
import { dimensions, mapData } from './mapping'
import { visualOptions } from './visualOptions'
import { render } from './render'

export default {
    metadata,
    dimensions,
    mapData,
    visualOptions,
    render,
}
